import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Lock, User, ArrowLeft, ArrowRight } from "lucide-react";

export default function Register() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle registration logic
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-[#fef8f5] flex items-center justify-center py-16 px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg space-y-8">
        <Link
          to="/"
          className="flex gap-x-2 items-center text-[#809080] hover:underline"
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </Link>

        <div className="text-center">
          <h2 className="text-4xl font-serif font-bold text-[#7a6e5f]">
            Create Account
          </h2>
          <p className="mt-2 text-[#7a6e5f] opacity-80">
            Sign up and join the <span className="font-medium">SuprSkin</span> community
          </p>
        </div>

        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* Name Fields */}
          <div className="flex gap-4">
            <div className="w-1/2">
              <label className="block text-sm font-medium text-[#7a6e5f] mb-1">
                First Name
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  className="block w-full px-4 py-3 pl-11 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
                  placeholder="First"
                />
                <User className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
              </div>
            </div>

            <div className="w-1/2">
              <label className="block text-sm font-medium text-[#7a6e5f] mb-1">
                Last Name
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  className="block w-full px-4 py-3 pl-11 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
                  placeholder="Last"
                />
                <User className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
              </div>
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-[#7a6e5f] mb-1">
              Email address
            </label>
            <div className="relative">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                autoComplete="email"
                required
                className="block w-full px-4 py-3 pl-12 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
                placeholder="you@example.com"
              />
              <Mail className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-[#7a6e5f] mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="block w-full px-4 py-3 pl-12 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
                placeholder="••••••••"
              />
              <Lock className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
            </div>
          </div>

          {/* Confirm Password */}
          <div>
            <label className="block text-sm font-medium text-[#7a6e5f] mb-1">
              Confirm Password
            </label>
            <div className="relative">
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                className="block w-full px-4 py-3 pl-12 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
                placeholder="••••••••"
              />
              <Lock className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full bg-[#7a6e5f] text-white py-3 rounded-md font-medium hover:bg-[#6a5e53] transition"
          >
            Create Account
          </button>

          {/* Already registered */}
          <div className="text-center text-sm text-[#7a6e5f]">
            Already have an account?{" "}
            <Link
              to="/login"
              className="inline-flex items-center gap-1 font-medium hover:underline"
            >
              <ArrowRight className="w-4 h-4" />
              Sign in
            </Link>
          </div>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-[#ddd]" />
            </div>
            <div className="relative flex justify-center text-sm text-[#a39285] bg-white px-2">
              or continue with
            </div>
          </div>

          {/* Social login */}
          <div className="grid grid-cols-2 gap-4">
            <button
              type="button"
              className="w-full flex items-center justify-center gap-2 border border-gray-300 rounded-md py-2 bg-white hover:bg-gray-50 transition"
            >
              <img
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                alt="Google"
                className="w-5 h-5"
              />
              <span className="text-sm text-[#7a6e5f]">Google</span>
            </button>
            <button
              type="button"
              className="w-full flex items-center justify-center gap-2 border border-gray-300 rounded-md py-2 bg-white hover:bg-gray-50 transition"
            >
              <img
                src="https://www.svgrepo.com/show/475647/facebook-color.svg"
                alt="Facebook"
                className="w-5 h-5"
              />
              <span className="text-sm text-[#7a6e5f]">Facebook</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
